module.exports = function _isFunction(x) {
  return Object.prototype.toString.call(x) === '[object Function]';
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/ramdasauce/~/ramda/src/internal/_isFunction.js
 ** module id = 94
 ** module chunks = 0
 **/